import { render, staticRenderFns } from "./YlwLogout.vue?vue&type=template&id=15c993c8&"
import script from "./YlwLogout.vue?vue&type=script&lang=js&"
export * from "./YlwLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports